import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { captureAttributionFromUrl } from "@/lib/siteAttribution";

// #568 — keep the public site's ?vid=&utm_*= from whatever page a learner lands
// on first, before any redirect or the OAuth round-trip drops the query.
captureAttributionFromUrl();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
